// Redux Phases module
// see https://github.com/erikras/ducks-modular-redux

import moment from 'moment';
import { Phases } from '../../services';
import { createRestSlices, applyReducers } from './rest';

const START_CREATING_PHASE = `kronos/${Phases.resource}/START_CREATING_ITEM`;

function default_new_phase_document() {
    return {
        name: {},
        start_at: moment().startOf('day').toISOString(),
        stop_at: moment().add(1, 'week').endOf('day').toISOString(),
    };
}

const {
    initialState,
    getReducer, listReducer, updateReducer, duplicateReducer,
    startCreateReducer, createReducer, deleteReducer,
    getAction, listAction, updateAction, duplicateAction,
    startCreateAction, createAction, deleteAction,
    linkedResourcesReducer, linkedResourcesAction
} = createRestSlices(Phases);

/* Export reducer */
export default (state = initialState, action) => {
    const next = applyReducers(state, action, [
        getReducer, listReducer, updateReducer, duplicateReducer,
        startCreateReducer, createReducer, deleteReducer,
        linkedResourcesReducer
    ]);

    if (action.type === START_CREATING_PHASE) {
        return {
            ...next,
            phase: default_new_phase_document(),
        };
    }

    return next;
}

/* Export CRUD actions */
export const startCreatePhase         = startCreateAction;
export const createPhase              = createAction;
export const loadPhase                = getAction;
export const loadPhases               = listAction;
export const updatePhase              = updateAction;
export const deletePhase              = deleteAction;
export const duplicatePhase           = duplicateAction;
export const getPhasesLinkedResources = linkedResourcesAction;
